document.addEventListener('DOMContentLoaded', function() {
    if ($('#success').length > 0) {
        $('html, body').animate({scrollTop: $('#success').offset().top - 50}, 0);
    }
});
